<template>
    <section class="dpp-photo" :class="getCategories.length > 1 ? 'has-categories' : ''">
        <div class="photos">
            <slot name="tag"></slot>
            <ul class="photoScroller" ref="mainPhotoScroller" @scroll="mainPhotoScrolledDebounced">
                <li @click.stop="openPhotoView(true)" v-for="(item, i) in getPhotos" :key="item.path">
                    <picture>
                        <source media="(max-width: 639px)" :srcset="`${item.path}${item._p}`">
                        <source media="(min-width: 640px) and (max-width: 1399px)" :srcset="`${item.path}${item._r}`">
                        <source media="(min-width: 1400px)" :srcset="`${item.path}${item._l}`">
                        <img :class="{ 'img-watermark': showWatermark() }" :loading="i > 0 ? 'lazy' : undefined" fetchpriority="auto" :title="`${item.cate ? item.cate + ' -' : ''} ${dpp.geo.formatAddress} photo ${item.index + 1}${item.cateCount ? ' of ' + item.cateCount : ''}`"  :src="`${item.path}${item._p}`" />
                    </picture>
                </li>
                <template v-for="(image,i) in mapImages" :key="image.type">
                    <li @click.stop="popMapView(i)" :class="image.type">
                        <mvtMapStatic  ref="map" class="img" :placeholder="image.placeholder" :eager="image.eager" :lat="dpp.geo.lat" :lng="dpp.geo.lng" :type="image.type" :index="getPhotos.length + i" :address="image.type === 'streetview' ? dpp.geo.formatAddress : undefined" :streetViewDefautType="image.fallback" :zoom="image.type === 'satellite' ? 18 : 15" @urlLoaded="getUrl" />
                    </li>
                </template>
                <li class="photo-panel" v-if="dpp.isActive && isMounted">
                    <div class="f4 text-bold">See this property in person.</div>
                    <button type="button" @click="openHotlead('Take a Tour')" class="btn primary regular">Request a Tour</button>
                </li>
            </ul>
            <button class="btn-prev" type="button" aria-label="Previous" :class="{ hidden: leftScrollHidden }" @click.stop="scrollLeft">
                <i class="icon-angle-left"></i>
            </button>
            <button class="btn-next" type="button" aria-label="Next" :class="{ hidden: rightScrollHidden }" @click.stop="scrollRight">
                <i class="icon-angle-right"></i>
            </button>
        </div>
        <div ref="categoryScroller" class="categories" :class="{ 'hidden-top': categoryScrollUpHidden, 'hidden-bottom': categoryScrollDownHidden }" v-if="getCategories.length > 1"  comp="category_scroller">
            <button class="button-up" aira-label="Scroll up" type="button"  @click="scrollCategoriesUp">
                <i class="icon-angle-up"></i>
            </button>
            <ul @scroll="categoriesScrolledDebounced"  ref="categoryPhotoScroller" >


                <li v-for="item in getCategories" @click="setCategory(item.cateIndex, item.index)" :key="item.tag" :class="{ active: item.cateIndex === categoryIndex }">
                    <span v-if="item.tag" class="photoTag">{{ item.tag }}</span>
                    <img :title="`${item.tag ? item.tag + ' -' : ''} ${dpp.geo.formatAddress} photo ${item.index + 1}${item.count ? ' of ' + item.count : ''}`" :src="`${item.path}${item._p}`" loading="lazy">
                </li>
                <li class="3d" v-if="dpp.threeDTourLink" @click="pop3d('3D')">
                    <div class="btn-3d">
                        <img loading="lazy" :src="`${glb.cdnUrl}vimages/home_animate.svg`" alt="Animated home icon">
                        <span class="btnTag">3D tour</span>
                    </div>
                </li>
                <li class="3d" v-if="dpp.videoTourLink" @click="pop3d('video')">
                    <div class="btn-3d">
                        <i class="icon-virtual-3D"></i>
                        <span class="btnTag">Video tour</span>
                    </div>
                </li>
            </ul>
            <button class="button-down" aria-label="Scroll down" type="button" @click="scrollCategoriesDown">
                <i class="icon-angle-down"></i>
            </button>
        </div>
    </section>
</template>

<script src="./dpp-photo.js"></script>

<style lang="scss">
  @use './dpp-photo.scss' as *;
</style>
